import { Plugin } from '@ckeditor/ckeditor5-core';

export class LinkEditor extends Plugin {

    static get pluginName() {
        return 'LinkEditor'
    }

    init() {
        const editor = this.editor;

        this.listenTo(editor.model, 'deleteContent', () => {
            const changes = editor.model.document.differ.getChanges();

            // Check for changes as insertContent event also triggers a deleteContent event with no changes due to event bubbling
            // Undo changes when deleting content from a link.
            if (editor.model.document.selection.getAttribute('linkHref') && changes.length){
                const undoCommand = editor.commands.get('undo');
                undoCommand?.execute()
            }
        })

        this.listenTo(editor.model, 'insertContent', () => {
            // Undo changes when inserting content to a link.
            if (editor.model.document.selection.getAttribute('linkHref')){
                const undoCommand = editor.commands.get('undo');
                undoCommand?.execute()
            }
        })

        editor.model.document.on( 'change', () => {
            // Disable link editing.
            if(editor.model.document.selection.getAttribute('linkHref')) {
                const linkCommand = editor.commands.get('link');
                linkCommand!.forceDisabled('LinkEditor');
            }
        } );
    }
}